module.exports = __webpack_public_path__ + "img/tree-04-e-leaves.9a3e5327.png";